//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {upFromTaskView} from '../utils.js';

export default {
  computed: {
    allIds() {
      if (!this.$taskCardsController ||
          !this.$taskCardsController.attachCandidatesIds) {
        return [];
      }
      return Object.keys(this.$taskCardsController.attachCandidatesIds);
    },
    inTaskView() {
      return 'taskId' in this.$route.params;
    },
  },
  methods: {
    goUp() {
      upFromTaskView(this);
    },
  }
}
